import { addDays, format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { FORMAT_FULL_DATE_MINI, FORMAT_QT_DATE } from 'utils/helpers/datetime';

export function formatFullDateMini(date) {
  return format(date, FORMAT_FULL_DATE_MINI);
}

export function formatQtDate(date) {
  const { timezone } = ecom.craftConfig;

  return formatInTimeZone(date, timezone, FORMAT_QT_DATE);
}

export function getRouteIdBySegmentIds(segmentIds, segments) {
  const targetSegment = Object.values(segments)
    .filter((segment) => segmentIds.includes(segment.id))
    .find((segment) => segment.is_primary_segment);

  return targetSegment?.qt_route_id;
}

export function getPeriodList(firstDate, days = 6) {
  const result = {};
  result[formatFullDateMini(firstDate)] = formatQtDate(firstDate);
  let i = 1;

  while (i <= days) {
    const futureDate = addDays(firstDate, i);
    result[formatFullDateMini(futureDate)] = formatQtDate(futureDate);

    i++;
  }

  return result;
}
